import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { startAuthUrlListener } from './AuthFromUrl.js';

/**
 * Component that watches for route changes and checks for auth parameters in the URL
 * Should be placed inside Router component to access location
 */
function AuthUrlWatcher({ setIsLoggedIn }) {
  const location = useLocation();
  
  useEffect(() => {
    console.log('🔄 Route changed to:', location.pathname);
    
    // Start listening for auth params in URL on each route change
    const cleanup = startAuthUrlListener(() => {
      console.log('🔐 Auth callback triggered, setting isLoggedIn to true');
      setIsLoggedIn(true);
    });
    
    // Cleanup listener when route changes or component unmounts
    return () => {
      cleanup();
    };
  }, [location, setIsLoggedIn]);
  
  return null; // This component doesn't render anything
}

export default AuthUrlWatcher;

